import { CreateMixin } from "@pdfking/reactivity/preact"

export const ViewMixin = CreateMixin({
  props: {
    // A compact array lays its entries out in one shared grid, so each field
    // is a single track (`col-span-1`) instead of its own `col_size` width.
    cell: false,
    className: "",
    compact_mode: false,
    hide_labels: false,
    onchange: undefined as (() => void) | undefined,
  },
})
